import { Route, NavigationGuardNext } from "vue-router";

export const VpcOverviewResolver = async function (to: Route, from: Route, next: NavigationGuardNext) {
	const actions: Promise<void>[] = [];
	await Promise.all(actions);
	next();
};
